import { Dispatch } from 'redux';
import { axiosInstance, request } from './base';

export interface DivergenciaItem {
  nomeCampo: string;
  valorInstrumento: string;
  valorDesminutador: string;
  tipoCampo: string;
  secao: string;
}

export interface ValidacaoInfo {
  id: string;
  status: string;
  instrumentoId: number;
  documentId: string;
  createdAt: string;
  updatedAt: string;
}

export interface DivergenciasData {
  validacao: ValidacaoInfo;
  divergencias: DivergenciaItem[];
  instrumentoCodigo: string;
  instrumentoTipo: string;
  dataValidacao: string;
  totalDivergencias: number;
}

export interface GetDivergenciasParams {
  instrumentoFinanceiroId: string;
}

export const getDivergenciasValidacao = async (
  dispatch: Dispatch,
  params: GetDivergenciasParams,
  stackRequest: boolean = false
): Promise<DivergenciasData> => {
  const url = `api/v1/instrumentos-financeiros/${params.instrumentoFinanceiroId}/validacao/divergencias`;
  
  return await request(
    () => axiosInstance.get<DivergenciasData>(url),
    dispatch,
    undefined,
    stackRequest
  );
};

export interface ReprocessarValidacaoParams {
  instrumentoFinanceiroId: string;
}

export const reprocessarValidacao = async (
  dispatch: Dispatch,
  params: ReprocessarValidacaoParams,
  stackRequest: boolean = false
): Promise<void> => {
  const url = `api/v1/instrumentos-financeiros/${params.instrumentoFinanceiroId}/validacao/reprocessar`;
  
  return await request(
    () => axiosInstance.post<void>(url),
    dispatch,
    undefined,
    stackRequest
  );
};
